import React from 'react';
import css from './CustomUiButton.module.scss';
import classnames from 'classnames';
import { svgSprite } from '../../hybrid/wrappers';
import T from '../../common/components/T';

const CustomUiButton = ({
    text = '',
    type = 'main',
    link_params = {},
    functional_type = 'default',
    classes = [],
    onClick = () => {},
    status = 'normal',
    style = {}
}) => {
    switch (functional_type) {
        case 'kaspi':
            return (
                <button onClick={onClick} className={css.kaspi}>
                    <p>
                        <T textName='pay-with' defaultStr='Оплатить с' />
                    </p>
                    {svgSprite('kaspi-colored-icon-1')}
                </button>
            );
        case 'default':
            return (
                <button style={{ ...style }} className={classnames(css[type], ...classes)} onClick={onClick} data-status={status}>
                    {text}
                </button>
            );
        case 'link':
            return (
                <a {...link_params}>
                    <button
                        style={{ ...style }}
                        className={classnames(css[type], ...classes)}
                        onClick={onClick}
                        data-status={status}
                    >
                        {text}
                    </button>
                </a>
            );
    }
};

export default CustomUiButton;
